import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-claim-reference-bloc',
  templateUrl: './claim-reference-bloc.component.html',
  styleUrls: ['./claim-reference-bloc.component.scss']
})
export class ClaimReferenceBlocComponent implements OnInit {

  @Input() claimReference: string;
  @Input() claimInformation: string;

  constructor() { }

  ngOnInit(): void {}

}
